import Axios from 'axios';
import {AxiosProcessor} from "../../shared/axios/AxiosProcessor";
const urlDocumentGroup = '/documentGroup';

const state = {
    documentGroup: {},
    documentGroups:{
        REPORT: {
            ALL:[],
            EMPLOYEE:[],
            CLIENT:[]
        },
        DOCUMENT: {
            ALL:[],
            EMPLOYEE:[],
            CLIENT:[]
        }
    },
    documentGroupDetails: {},
    documentGroupsPageKey:{}
};

const getters = {
    getDocumentGroup: state => {
        return state.documentGroup;
    },
    getDocumentGroups: state => (data) => {
        let apply = data.applyTo ? data.applyTo : 'ALL';
        return state.documentGroups[data.type][apply];
    },
    getDocumentGroupDetails: state => {
        return state.documentGroupDetails;
    },
    getDocumentGroupsPageKey : state => {
        return state.documentGroupsPageKey;
    }
};

const mutations = {
    setDocumentGroup: (state, data) => {
        state.documentGroup = data;
    },
    setDocumentGroups: (state, data) => {
        let apply = data.applyTo ? data.applyTo : 'ALL';
        state.documentGroups[data.type][apply] = data.value;
    },
    setDocumentGroupDetails: (state, data) => {
        state.documentGroupDetails = data;
    },
    setDocumentGroupsPageKey: (state, data) => {
        state.documentGroupsPageKey = data;
    }
};

const actions = {
    async setDocumentGroup ({commit}, data) {
        //going backend
        let value = {};

        try{
            let response = {};
            if(!!!data.id) {
                response  = await Axios.post(urlDocumentGroup, data);
            }
            else {
                response = await Axios.put(urlDocumentGroup+'/' + data.id, data);
            }
            value = response.data.body;
        }
        catch (e) {
            console.log('Error: ', e);
            throw e;
        }
        commit('setDocumentGroup', value);
    },
    async getDocumentGroup ({commit}, data) {

        let id = data.id;

        if (!id)
            throw {message: 'empty id. Please provide a valid id value'};

        /**
         * First we check the state
         * then we check the list
         * then we go to backend
         */
        if(state.documentGroup && state.documentGroup.id && state.documentGroup.id === id)
            return;

        let documentGroup;
        let value = {};

        let apply = data.applyTo ? data.applyTo : 'ALL';
        if (data.type && state.documentGroups[data.type][apply].length > 0) {
            documentGroup  = state.documentGroups[data.type][apply].find(doc => doc.id === id);
        }

        if(documentGroup)
        {
            value = documentGroup;
        }
        else
        {
            let response = await AxiosProcessor.get(urlDocumentGroup+'/'+id);

            if(!!!!response && response.Item)
                value = response.Item;
        }

        commit('setDocumentGroup', value);
    },
    async getDocumentGroups ({commit}, data) {

        if(!data.type)
            throw {message: 'empty type. Please provide a valid type value'};

        let type = data.type;
        delete data.type;

        //going backend,
        let value = [];
        let response = await AxiosProcessor.list(urlDocumentGroup+'/types/'+type, data);

        if(response.Items)
            value = response.Items;

        commit('setDocumentGroups', {type: type, applyTo: data.applyTo, value: value});
    },
    async getDocumentGroupDetails ({commit}, data){
        //going backend,
        let value = {};
        try{
            let response = await AxiosProcessor.get('/counter/documentGroup');
            value = response.Item;
        }
        catch (e) {
            console.log('Error: ', e);
            throw e;
        }
       commit('setDocumentGroupDetails', value);
    },
    async deleteDocumentGroup ({commit}, data){
        //going backend,
        let value = {};
        try{
            value = await AxiosProcessor.delete(urlDocumentGroup+'/'+data.id);
        }
        catch (e) {
            console.log('Error: ', e);
            return;
        }
        commit('setDocumentGroup', value);
    }
};

export default {
    state,
    getters,
    mutations,
    actions
}